import type { SelectHTMLAttributes, ReactNode } from 'react'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  readonly hasError?: boolean
  readonly children: ReactNode
}

export function Select({ hasError = false, className, children, ...rest }: SelectProps): JSX.Element {
  const classes = [
    'w-full font-body text-body px-3 py-2 rounded-md',
    'bg-white border-[1.5px] outline-none transition cursor-pointer',
    hasError ? 'border-terra focus:border-terra' : 'border-border focus:border-forest',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <select className={classes} {...rest}>
      {children}
    </select>
  )
}
